import React from 'react';
import { allmonth } from '../../helpers/utils';
import { TableRowComponent } from './TableRowComponent';

interface IProps {
  moduleData: any;
  handleBulkDeleteFeature: any;
  selectionArray: any;
  updateModuleData: any;
  settings: any;
  perPage:any;
  page:any;
  autoCompleteData: any;
}
const TBody = ({
  moduleData,
  selectionArray,
  updateModuleData,
  handleBulkDeleteFeature,
  autoCompleteData,
  settings,
  perPage,
  page,
}: IProps) => {
  return (
    <tbody>
      {moduleData.map((item: any, index: any) => (
        <TableRowComponent
          key={item?._id || `${index}_table_row`}
          item={item}
          index={index}
          allmonth={allmonth}
          updateModuleData={updateModuleData}
          handleBulkDeleteFeature={handleBulkDeleteFeature}
          selectionArray={selectionArray}
          autoCompleteData={autoCompleteData}
          settings={settings}
          moduleData={moduleData}
          perPage={perPage}
          page={page}
        />
      ))}
    </tbody>
  );
};

export default React.memo(TBody);
